
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Paper,
  TextField,
  Tooltip,
  Typography,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Divider,
  SelectChangeEvent,
  Select,
  MenuItem,
} from "@mui/material";
import variables from "../../../assets/styles/variables.module.scss";
import SummaryCard from "../../../Shared-ui/SharedComponents/Cards/SummaryCard";
import AddIcon from "@mui/icons-material/Add";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { SetStateAction, useEffect, useState } from "react";
import { Slack } from "../../../Shared-ui/Types/common";
import OldAgent from "../../../Shared-ui/Types/OldAgent";
import Template from "../../../Shared-ui/Types/Template";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { useDispatch } from "react-redux";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";
import Confirm from "../../../Shared-ui/Types/Confirm";
//import FormView from "./formView";

interface MyComponentProps {
  knowledgeBase: OldAgent | Template | any;
  setknowledgeBase: React.Dispatch<SetStateAction<OldAgent | Template | any>>;
  getknowledgeBase: () => void;
  updateknowledgeBase: () => void;
}


const SourceSlack: React.FC<MyComponentProps> = (props) => {
  const slackInitial = {
    id: 0,
    name: "",
    slackToken: "",
    channelId: ""
  }
  const slackErrInitial = {
    name: { value: false, error: "" },
    slackToken: { value: false, error: "" },
    channelId: { value: false, error: "" },
  }
  const [slackErr, setSlackErr] = useState(slackErrInitial)
  const [slack, setSlack] = useState<Slack>(slackInitial)
  const [slacks, setSlacks] = useState<Slack[]>([])
  const [expanded, setExpanded] = useState<boolean>(false); // Track expanded panel
  const [isEditing, setIsEditing] = useState<boolean>(false); // Track expanded panel
   const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({ show: false, });
  const dispatch = useDispatch()


  useEffect(() => {
    setSlacks(props.knowledgeBase?.slack || [])
  }, [props.knowledgeBase])



  const handleCreate = () => {
    setExpanded(true); // Reset expanded state
    setSlack(slackInitial)
    setIsEditing(false)
  };


  const handleCancel = () => {
    setExpanded(false); // Reset expanded state
    setSlack(slackInitial)
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target
    setSlack(preVal => ({ ...preVal, [name]: value }))
  }

  const handleSave = (slackId?: number) => {
    if (!validateSlack()) return;

    if (slackId === null || slackId === undefined) {
      props.setknowledgeBase((preVal: OldAgent) => {
        const existingSlack = preVal.slack || []
        slack.id = existingSlack[existingSlack?.length - 1] && existingSlack[existingSlack?.length - 1].id >= 0 ? existingSlack[existingSlack?.length - 1].id + 1 : 0
        const updatedSlack = [slack, ...existingSlack]
        preVal.slack = updatedSlack
        return preVal
      })
    }
    else {
      props.setknowledgeBase((preVal: OldAgent) => {
        const existingSlack = preVal.slack || []
        existingSlack[slackId].name = slack.name
        existingSlack[slackId].slackToken = slack.slackToken
        existingSlack[slackId].channelId = slack.channelId
        preVal.slack = existingSlack
        return preVal
      })
    }
    setSlack(slackInitial)
    setExpanded(false)
    props.updateknowledgeBase()
  };


  const validateSlack = () => {
    let ErrCount = 0
    if (!slack.name?.trim()) {
      setSlackErr((preVal) => ({ ...preVal, name: { error: "Please enter the name", value: true } }))
      ErrCount += 1
    } else {
      setSlackErr((preVal) => ({ ...preVal, name: { error: "", value: false } }))
    }

    if (!slack.channelId?.trim()) {
      setSlackErr((preVal) => ({ ...preVal, channelId: { error: "Please enter the channelId", value: true } }))
      ErrCount += 1
    } else {
      setSlackErr((preVal) => ({ ...preVal, channelId: { error: "", value: false } }))
    }

    if (!slack.slackToken?.trim()) {
      setSlackErr((preVal) => ({ ...preVal, slackToken: { error: "Please enter the slackToken", value: true } }))
      ErrCount += 1
    } else {
      setSlackErr((preVal) => ({ ...preVal, slackToken: { error: "", value: false } }))
    }

    if (slacks.some((item: Slack) => item.channelId === slack.channelId) && !isEditing) {
      dispatch(ShowError("Link  already exist"))
      ErrCount += 1
    }
    return ErrCount === 0 ? true : false
  }

    const handleEdit = (slackId: number) => {
      const youTube = slacks?.filter((faq: Slack) => faq.id === slackId)[0]
      setSlack(youTube)
      setExpanded(true)
      setIsEditing(true)
    }
  
    const handleDelete = (slackId: number) => {
      setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
      props.setknowledgeBase((preVal: OldAgent) => {
        const existingSlack= preVal.slack || []
        const updatedSlack = existingSlack?.filter((faq: Slack) => faq.id !== slackId)
        preVal.slack = updatedSlack
        return preVal
      })
      props.updateknowledgeBase()
    }
  
    const deleteConfirm = (row: number) => {
      setConfirmPopupData({
        show: true,
        setConfirmPopupData: setConfirmPopupData,
        title: "Confirm Delete",
        info: "Are you sure want to delete your data? This action cannot be undone.",
        varient: "delete",
        functionName: handleDelete,
        functionParam: row,
      });
    };
  
  

  const columns: GridColDef[] = [
    // { field: "id", headerName: "ID", width: 70 },
    { field: "name", headerName: "Name", width: 180 },
    { field: "slackToken", headerName: "Slack Token", width: 250 },
    { field: "channelId", headerName: "Channel Id", width: 250 },

    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => {
        const handleEditClick = (event: React.MouseEvent) => {
          event.stopPropagation(); // Prevent row selection
          handleEdit(params.row.id)
        };

        const handleDeleteClick = (event: React.MouseEvent) => {
          event.stopPropagation(); // Prevent row selection
          deleteConfirm(params.row.id)
         
        };

        return (
          <Box>
            <IconButton aria-label="view" onClick={() => setExpanded(true)}>
              <VisibilityIcon />
            </IconButton>
            <IconButton aria-label="edit">
              <EditOutlinedIcon />
            </IconButton>
            <IconButton aria-label="delete">
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Box>
        );
      },
    },
  ];




  return (
    <Box
      sx={{
        width: "100%",
        display: "block",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          ml: -2,
          mr: -2,
        }}
      >
        {/* Left Content */}
        <Box
          sx={{
            width: {
              lg: "calc(100% - 300px)",
              md: "calc(100% - 300px)",
              sm: "100%",
            },
            flex: "0 0 auto",
            boxSizing: "border-box",
            minWidth: {
              lg: "calc(100% - 300px)",
              md: "calc(100% - 300px)",
              sm: "100%",
            },
            pl: 2,
            pr: 2,
            maxWidth: "100%",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Slack
            </Typography>
            <Box>
              <Tooltip title="Add Slack" placement="top">
                <IconButton
                  color="secondary"
                  aria-label="add icon"
                  sx={{ color: variables.primaryColor }}
                  onClick={() => handleCreate()}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          {/* Add Connection Box */}
          {expanded && (
            <Box
              sx={{
                "&::before": {
                  content: '""',
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 7,
                },
              }}
            >
              <Box
                sx={{
                  width: "500px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                  pt: "10px",
                  position: "fixed",
                  right: "0",
                  top: "0",
                  height: "100vh",
                  background: variables.whiteColor,
                  padding: "20px 30px",
                  zIndex: 8,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    height: "100%",
                  }}
                >
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography variant="h6" gutterBottom>
                        New Slack
                      </Typography>
                      <IconButton aria-label="close" onClick={handleCancel}>
                        <CloseIcon />
                      </IconButton>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 3,
                        mt: 2,
                        pt: "5px",
                        height: "calc(100vh - 160px)",
                        overflow: "auto",
                      }}
                    >
                      <FormControl fullWidth variant="outlined" required error={slackErr.name.value}>
                        <InputLabel
                          htmlFor="name"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Name
                        </InputLabel>
                        <TextField
                          //size="small"
                          error={slackErr.name.value}
                          helperText={slackErr.name.error}
                          value={slack.name}
                          onChange={handleChange}
                          id="name"
                          name="name"
                          placeholder="Enter the name"
                          sx={{ background: "white" }}
                        />
                      </FormControl>


                      <FormControl fullWidth variant="outlined" required error={slackErr.slackToken.value}>
                        <InputLabel
                          htmlFor="siteName"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Slack Token
                        </InputLabel>
                        <TextField
                          // size="small"
                          error={slackErr.slackToken.value}
                          helperText={slackErr.slackToken.error}
                          value={slack.slackToken}
                          onChange={handleChange}
                          id="slackToken"
                          name="slackToken"
                          placeholder="Enter Slack Token"
                          sx={{ background: "white" }}
                        />
                      </FormControl>
                      <FormControl fullWidth variant="outlined" required error={slackErr.channelId.value}>
                        <InputLabel
                          htmlFor="folderPath"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Channel Id
                        </InputLabel>
                        <TextField
                          // size="small"
                          error={slackErr.channelId.value}
                          helperText={slackErr.channelId.error}
                          value={slack.channelId}
                          onChange={handleChange}
                          id="channelId"
                          name="channelId"
                          placeholder="Enter Channel Id"
                          sx={{ background: "white" }}
                        />
                      </FormControl>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      gap: 2,
                      justifyContent: "flex-end",
                      position: "absolute",
                      bottom: 0,
                    }}
                  >
                    <Button
                      fullWidth
                      variant="outlined"
                      disableElevation
                      size="large"
                      sx={{
                        textTransform: "capitalize",
                      }}
                      onClick={handleCancel} // Call handleCancel on click
                    >
                      Cancel
                    </Button>
                    <Button
                      fullWidth
                      variant="contained"
                      disableElevation
                      size="large"
                      sx={{
                        textTransform: "capitalize",
                      }}
                      onClick={() => handleSave(isEditing ? slack.id : undefined)}
                    >
                      Save
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}


          <Paper sx={{ height: 400, width: "100%", mt: "20px" }} elevation={0}>
            <DataGrid
              rows={slacks}
              columns={columns}
              // initialState={{ pagination: { paginationModel } }}
              pageSizeOptions={[10]}
              paginationMode="client"
              pagination={true}
              //checkboxSelection
              // components={{
              //   NoRowsOverlay: CustomNoRowsOverlay, // Correctly reference the custom component
              // }}
              sx={{
                border: 1,
                borderColor: variables.borderColor,
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "& .MuiDataGrid-cell:focus-within": {
                  outline: "none",
                },
              }}
            />
          </Paper>
        </Box>

        {/* Right Summary Card */}
        <Box
          sx={{
            width: { lg: "300px", md: "300px", sm: "100%" },
            minWidth: { lg: "300px", md: "300px", sm: "100%" },
            boxSizing: "border-box",
            flex: "0 0 auto",
            pl: 2,
            pr: 2,
            mt: { lg: "0", md: "0", sm: "30px" },
          }}
        >
          <SummaryCard />
        </Box>
      </Box>
      <ConfirmPopup details={confirmPopupData} />
    </Box>
  );
};

export default SourceSlack;

